import Request from "./request";
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'

// 当前库位
async function fetch(data) {
  return Request("get", "api/position-currents/", data);
}

// 导出当前库位
async function exports(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/position-currents/export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}


// async function fetchOne(id,data) {// 获取单个
//     return Request('get', "api/position-currents/" + id, data);
// }

export default {
  fetch,
  exports,
//   fetchOne,
};
